/**
 * ScrollableContainer
 *
 * Adds a reusable scrollable area with themed scrollbar styling and optional
 * max-height constraints.
 * Used by shared cards and pages such as `AppointmentsCard`, `BookingPage`,
 * `StyleYourBusinessPage`, `MyCalendarTab`, and `MyBusinessTab`.
 */

import React from 'react';
import './ScrollableContainer.css';
import { COLOR_SCHEME, CLASSIC } from '../../styling/ColorSchemes';

interface ScrollableContainerProps {
  children: React.ReactNode;
  maxHeight?: string;
  style?: React.CSSProperties;
  className?: string;
  colorScheme?: COLOR_SCHEME; // used to theme scrollbar
}

const ScrollableContainer = React.forwardRef<HTMLDivElement, ScrollableContainerProps>(({
  children,
  maxHeight,
  style,
  className = '',
  colorScheme = CLASSIC,
}, ref) => {
  return (
    <div
      ref={ref}
      className={`scrollable-container ${className}`}
      style={{
        maxHeight,
        ['--scrollbar-color' as string]: colorScheme.PRIMARY,
        ...style,
      }}
    >
      {children}
    </div>
  );
});

ScrollableContainer.displayName = 'ScrollableContainer';

export default ScrollableContainer;
